import HeaderLabels from './HeaderLabels';

export default HeaderLabels;
